//#region  Imports
import { AgGridService } from '../../../shared/common-components/ag-grid/ag-grid.service';
import { MetalType, ModalPopupSize, VoucherType, VoucherTypeName } from "./../../../shared/models/common.model";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from "@angular/core";
import { NgbDropdown, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subscription, catchError } from "rxjs";
import { ResponseModel } from "../../../shared/models/response-model.model";
import { KeyCode, MetalSectionNavTab, SettingTypeKeys, StorageName } from "../../../shared/enum/common-enum";
import { StorageService } from "../../../shared/services/storage.service";
import { CommonService } from "../../../shared/services/common.service";
import { AgGridComponent } from "../../../shared/common-components/ag-grid/ag-grid.component";
import { EditDeleteIconService } from '../../../shared/common-components/ag-grid/edit-delete-icon/edit-delete-icon.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ComponentCanDeactivate } from '../../../shared/guard/direty-check.guard';
import { SendDataService } from '../../../shared/services/send-data.service';
import { TotalSectionComponent } from '../../../shared/common-components/total-section/total-section.component';
import { TaxSectionComponent } from '../../../shared/common-components/tax-section/tax-section.component';
import { PaymentSectionComponent } from '../../../shared/common-components/payment-section/payment-section.component';
import { ItemListSectionComponent } from '../../../shared/common-components/item-list-section/item-list-section.component';
import { TotalSectionModel } from '../../../shared/common-components/total-section/total-section.model';
import { MetalSectionModel } from '../../../shared/common-components/metal-section/metal-section.model';
import { CustomSelect2Component } from '../../../shared/common-components/custom-select2/custom-select2.component';
import { PaymentSectionModel } from '../../../shared/common-components/payment-section/payment-section.model';
import { ItemSectionModel } from '../../../shared/common-components/item-list-section/item-list-section.model';
import { TaxSectionModel } from '../../../shared/common-components/tax-section/tax-section.model';
import { LoadDropdownDataComponent } from '../../../shared/common-components/load-dropdown-data/load-dropdown-data.component';
import { InputDatepickerRendererComponent } from '../../../shared/common-components/ag-grid/input-datepicker-renderer/input-datepicker-renderer.component';
import { DateService } from '../../../shared/services/date.service';
import { CompressImageService } from '../../../shared/services/compress-image.service';
import { CommonCommentComponent } from '../../../shared/common-components/common-comment/common-comment.component';
import { MetalSectionService } from '../../../shared/common-components/metal-section/metal-section.service';
import { MetalSectionComponent } from '../../../shared/common-components/metal-section/metal-section.component';
import { CustomerDetailsComponent } from '../../../shared/common-components/common-voucher/popup/customer-details/customer-details.component';
import { TransactionService } from '../../../components/transaction/transaction.service';
import { AdministrationService } from '../../../components/administration/administration.service';
import { ReportService } from '../../../components/report/report.service';
import { AgainstOfPopupComponent  } from './popup/against-Of/against-of-popup.component';
import { CommonVoucherModel, FixingType } from '../../../shared/common-components/common-voucher/common-voucher.model';
import { PaymentListComponent } from '../payment-list/payment-list.component';
import { PaymentListSectionModel } from '../payment-list/payment-list.model';
import { NotificationService } from '../../services/notification.service';
import { MetalSectionChildComponent } from '../metal-section-child/metal-section-child.component';
import { AgGridI } from '../ag-grid/ag-grid.model';
import { AgGridDataModelExpensesGrid } from '../../../components/transaction/expenses/expenses.model';
import { SelectPrintFormatPopupComponent } from './popup/select-print-format-popup/select-print-format-popup.component';
import { SettingsService } from '../../../components/settings/settings.service';
import { GetAllSettingsResponceModel } from '../../../components/settings/set-software/tabs/voucher-setting/voucher-setting.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ExchangeRatesComponent } from './popup/exchange-rates/exchange-rates.component';
import { InvoiceService } from '../../../components/transaction/invoice/invoice.service';
import { ExcelConverterServiceService } from '../../services/excel-converter-service.service';
import { MastersService } from '../../../components/administration/masters/masters.service';
import { IpcRenderService } from '../../services/ipc-render.service';
import { ConfirmationPopUPComponent } from '../common-popup/confirmation-pop-up/confirmation-pop-up.component';
import { AgainstOf } from '../../../components/transaction/invoice/invoice.model';
import { CrmService } from '../../../components/administration/crm/crm.service';
import { LayoutDetails, User } from '../../../auth/auth.model';
import { JobWorkStatus } from '../../../components/orders/order-tracking/order-tracking.model';
import { AgGridDataModelSalePurchaseFixingDirectGrid } from '../../../components/transaction/transaction.model';
import { CreateSchemeComponent } from '../../../components/transaction/investment-fund/create-scheme/create-scheme.component';
import { TextProcessingService } from '../../services/text-processing.service';
import { StockJournalService } from '../../../components/transaction/stock-journal/stock-journal.service';
import { JournalVouchersPopupComponent } from './popup/journal-vouchers-popup/journal-vouchers-popup.component';
import { CommonAgGridDropdownService } from '../common-popup/common-ag-grid-dropdown/common-ag-grid-dropdown.service';
import { AccountGroupId } from './popup/customer-details/customer-details.model';
//#endregion
@Component({
  selector: "app-common-voucher",
  templateUrl: "./common-voucher.component.html",
  styleUrls: ["./common-voucher.component.scss"],
})
export class CommonVoucherComponent extends CommonService implements OnInit, OnDestroy, ComponentCanDeactivate, AfterViewInit {
  //#region  Initializations
  @ViewChild("InvoiceForm") InvoiceForm!: NgForm;
  @ViewChild(MetalSectionComponent) metalSectionComponent: MetalSectionComponent;
  @ViewChild(MetalSectionChildComponent) metalSectionChildComponent: MetalSectionChildComponent;
  @ViewChild(CustomSelect2Component) customSelect2Component: CustomSelect2Component;
  @ViewChildren(AgGridComponent) children: QueryList<AgGridComponent>;
  @ViewChild(TotalSectionComponent) totalSectionComponent: TotalSectionComponent;
  @ViewChild(TaxSectionComponent) taxSectionComponent: TaxSectionComponent;
  @ViewChild(PaymentSectionComponent) paymentSectionComponent: PaymentSectionComponent;
  @ViewChild(ItemListSectionComponent) itemListSectionComponent: ItemListSectionComponent;
  @ViewChild(LoadDropdownDataComponent) loadDropdownDataComponent: LoadDropdownDataComponent;
  @ViewChild(CommonCommentComponent) commonCommentComponent: CommonCommentComponent;
  @ViewChild(PaymentListComponent) paymentListComponent: PaymentListComponent;
  @ViewChild('invoiceDateComp') invoiceDateComponent: InputDatepickerRendererComponent;
  @ViewChild('dueDateComp') dueDateComponent: InputDatepickerRendererComponent;
  @ViewChild("layawaysDropdown") layawaysDropdown: CustomSelect2Component;
  @ViewChild("voucherTypeDropdown") voucherTypeDropdown: CustomSelect2Component;
  @ViewChild("againstInvoiceDropdown") againstInvoiceDropdown: CustomSelect2Component;
  @Output() onGetByIdResponse = new EventEmitter<any>();
  @Output() onGridReadyCompleted = new EventEmitter<any>();
  @Output() onItemListChangeResponse = new EventEmitter<any>();
  @Output() onDeleteItemClickResponse = new EventEmitter<any>();
  @Output() onInsertInvoiceResponce = new EventEmitter<any>();
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  isLoading: boolean = false;
  getAllDropdownModel: any = {};
  invoiceDate: any;
  dueDate: any;
  formModel: any = {};
  notificationConfigurationModel : any = {};
  rdlcResourceName: any = "";
  //common setion model 
  totalSectionModel = new TotalSectionModel();
  metalSectionModel = new MetalSectionModel();
  paymentSectionModel = new PaymentSectionModel();
  itemSectionModel = new ItemSectionModel();
  taxSectionModel = new TaxSectionModel();
  paymentListSectionModel = new PaymentListSectionModel();
  gridApiExpenses: any;
  gridApiFixingDirect: any;
  fileName ="";
  FilePath:any;
  selectedFile: File | null = null;
  voucherTypeName;
  //common setion model 
  private resetInvoiceSubscription: Subscription;
  @Input() commonVoucherModel = new CommonVoucherModel();

  //#region  Subscriptions
  _onSaveBeforeCloseSubscription!: Subscription;
  _onSaveAsDraftBeforeCloseSubscription!: Subscription;
  _onTabKeyPressedSubscription!: Subscription;
  onDeleteRowClickedSubscription!: Subscription;
  invoiceNoCalled!: Subscription;
  navigationThroughInvoiceNo!: Subscription;
  //#endregion  

  storage = StorageName;
  browserRefresh = false;
  sampleFileData: any;
  badgeCount: any;
  saleOrderNoDropdownFilterData: any;
  saleQuotationNoDropdownFilterData: any;
  salesInvoiceNoDropdownFilterData : any;
  purchaseInvoiceNoDropdownFilterData: any;
  purchaseQuotationNoDropdownFilterData: any;
  purchaseOrderNoDropdownFilterData : any;
  deliveryNoteNoDropdownFilterData: any;
  repairOrderNoDropdownFilterData: any;
  isSalePersonDropdownInitialized: boolean = false;
  agGridDataModelExpensesGrid: AgGridI;
  agGridDataModelSalePurchaseFixingDirectGrid: AgGridI;
  allColumns: any;
  copiedAgainstDropdown: any;
  getAllSettingsResponceModel:GetAllSettingsResponceModel[]=[];
  ledgerName: any;

  layoutDetails: LayoutDetails;
  user: User;
  selectedBaseCurrencyName: any;
  selectedCurrencyName: any;
  hideRecieveButton = false;
  //#endregion
  //#region Ctor
  isHidePaymentSection:boolean=false

  constructor(
    public metalSectionService: MetalSectionService,
    public renderer: Renderer2,
    public notificationService: NotificationService,
    public modalService: NgbModal,
    public transactionService: TransactionService,
    public storageService: StorageService,
    public administrationService: AdministrationService,
    public editDeleteIconService: EditDeleteIconService,
    public activatedRoute: ActivatedRoute,
    public toaster: ToastrService,
    public sendDataService: SendDataService,
    public router: Router,
    public agGridService: AgGridService,
    public elementRef: ElementRef,
    public reportService: ReportService,
    public cdrf: ChangeDetectorRef,
    public dateService: DateService,
    public compressImageService: CompressImageService,
    public settingsService: SettingsService,
    public invoiceService: InvoiceService,
    public excelConverterServiceService : ExcelConverterServiceService ,
    private ipcService                 : IpcRenderService,
    public toastrService:ToastrService,
    public mastersService : MastersService,
    private http: HttpClient,
    public crmService : CrmService,
    public textProcessingService : TextProcessingService,
    public stockJournalService:StockJournalService,
     public commonAgGridDropdownService :CommonAgGridDropdownService,
  ) {
    super(renderer);
    this.commonVoucherModel.isInvoiceNo;
    this._onTabKeyPressedSubscription = this.storageService?.onTabKeyPressed.subscribe((context) => {
      if (context != undefined)
        this.onCellKeyDownValue(context);
    });

    this.invoiceNoCalled = this.storageService?.invoiceNoCalled.subscribe((context) => {
      if (context != undefined && this.formModel?.invoiceModel) {
        this.formModel.invoiceModel.internalFix = context?.internalFix;
        this.formModel.invoiceModel.metalFix = context?.metalFix;
        this.formModel.invoiceModel.calculateAmountByFormulaId = context?.calculateAmountByFormulaId ?? 2;
        this.formModel.invoiceModel.doNotAllowZeroAmountProduct = context?.doNotAllowZeroAmountProduct;
        this.formModel.invoiceModel.salesPersonMandatory = context?.salesPersonMandatory;
        this.commonVoucherModel.isShowReferenceNo = context?.showReferenceNo;
        this.commonVoucherModel.isShowAgainstOf = context?.showAgainstOf;
        this.commonVoucherModel.isShowSalesperson = context?.showSalesperson;
        this.commonVoucherModel.isshowLayawaysDropdown = context?.showLayaways;
        this.commonVoucherModel.isShowFixingType = context?.showFixingType;
        this.commonVoucherModel.isShowCurrency = context?.showCurrency;
        this.commonVoucherModel.isShowDueDate = context?.showDueDate;
        this.notificationConfigurationModel = context?.notificationConfigurationModel;

        this.formModel.invoiceModel.fixingTypeId = context?.fixingTypeId;
        this.selectHedging(this.formModel?.invoiceModel?.fixingTypeId);

        this.formModel.checkPlanetConfiguration = context?.checkPlanetConfiguration;
        this.loadVoucherTypeWiseData(context?.taxAndMetalDetailsByVoucherType);
      }
    });
    this.navigationThroughInvoiceNo = this.storageService.navigationThroughInvoiceNo.subscribe((invoiceId: number | null | undefined) => {
      if (this.formModel.invoiceModel) {
        this.formModel.invoiceModel.id = invoiceId ?? null;
        this.getById();
      }
    });
    this.layoutDetails = this.storageService.retrieve(StorageName.LAYOUT_DETAILS);
    this.user = this.storageService.retrieve('user');
  }

  //#endregion
  //#region Save Confirmation
  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    var paymentListExist = this.formModel != null && this.formModel?.paymentList != undefined && this.formModel?.paymentList?.length > 0;
    var itemListExist = this.formModel != null && this.formModel?.itemList != undefined && this.formModel?.itemList?.length > 0
    return (
      !paymentListExist && !itemListExist && !itemListExist);
  }


  openMetalSectionPopup(previousRow) {
    this.metalSectionModel.previousRow = previousRow;
      if (this.commonVoucherModel.showMetalSectionSimple)
        this.metalSectionChildComponent.fillPreviousRow();
      else if(this.commonVoucherModel.showMetalSectionViewOnlyPopup)
      {
        this.metalSectionModel.addButton = false;
        this.metalSectionModel.moreButtonVisibility = false;
        this.metalSectionService.openMetalSectionPopup(this.metalSectionModel, this.formModel, "")
        .then(() => { this.isPopupOpen = false; })
        .catch(() => { this.isPopupOpen = false; });
      }
      else  this.metalSectionComponent.openMetalSectionPopup(previousRow);
  }

  ngOnInit() {
    this.commonVoucherModel.disableMetalSection = true;
    this.dateReceived();
    this.initialCalls();
    this.setVisibilityInstance();
    if(this.commonVoucherModel?.showExpensesWithTaxSwitch)this.getsamplefilebypagename();
    this._onSaveBeforeCloseSubscription = this.sendDataService.onSaveBeforeClose.subscribe((data) => this.onSave());
    this.resetInvoiceSubscription = this.storageService?.resetInvoiceEvent.subscribe(() => {
      this.resetInvoice();
      this.loadDropdownDataComponent?.getInvoiceNo();
    });
  }

  selectedDueDateRangeDates(event?: any) {
    this.dueDate = event;
  }

  gridReadyCompleted(event?: any) {
    this.onGridReadyCompleted.emit(true);
  }

  getAllSettingTypes() {
      this.settingsService?.getAllSetting().subscribe(item => {
        this.storageService.store(StorageName.AMOUNT_DECIMAL, item?.response?.filter(a => a?.settingTypeKeyId == SettingTypeKeys.AmountDecimal)[0]?.value);
        this.storageService.store(StorageName.REVERSE_CALCULATION_ON, item?.response?.filter(a => a.settingTypeKeyId == SettingTypeKeys.ReverseCalculationResult)[0]?.value);
        if (this.commonVoucherModel?.showMetalSection == true || this.commonVoucherModel?.showMetalSectionSimple == true) {
        var itemAsPopup = item?.response?.filter(a => a?.settingTypeKeyId == SettingTypeKeys.ItemAsPopup);
        if (itemAsPopup[0]?.value == 'true') {
          if(this.commonVoucherModel.showMetalSectionSimpleForce == false)
          {
            this.commonVoucherModel.showMetalSection = true;
            this.commonVoucherModel.showMetalSectionSimple = false;
          }
        }
        else {
          this.commonVoucherModel.showMetalSection = false;
          this.commonVoucherModel.showMetalSectionSimple = true;
        }
      }
        if (this.formModel.voucherType == VoucherTypeName.StockTransferIn) {
          const settingData = item?.response.find(
            (x) =>
              x?.settingTypeKeyId == SettingTypeKeys.StockTransferReceiveProcess
          );
          if (settingData?.value != "true") {
            this.hideRecieveButton = true;
            this.itemListSectionComponent.setColumnsVisible(["active", "recieved"], false);
          }
        }
      });
    
  }
  dateReceived() {
    this.dateService.getSelectedDate().subscribe(date => {
      if (date)
        this.invoiceDate = date;
    });
  }

  initialCalls(previousInvoiceModel: any = undefined) {
    const element = document.getElementById("customerNameId") as any;
    element?.focus();
    this.isLoading = true;
    this.formModel = {};
    this.formModel.invoiceModel = {};
    this.formModel.voucherType = this.commonVoucherModel?.voucherType;
    this.formModel.invoiceModel.voucherTypeId = this.commonVoucherModel?.voucherTypeId;
    this.formModel.invoiceModel.id = this.storageService.retrieve(this.commonVoucherModel?.invoiceIdName);
    this.formModel.isPrint = undefined;
    if (previousInvoiceModel != undefined) {
      this.formModel.invoiceModel.internalFix = previousInvoiceModel?.internalFix;
      this.formModel.invoiceModel.metalFix = previousInvoiceModel?.internalFix;
      if ((this.commonVoucherModel.voucherTypeId == VoucherType.ExpenseInvoice || this.commonVoucherModel?.voucherTypeId == VoucherType.IncomeInvoice) && this.gridApiExpenses) {
        this.gridApiExpenses?.api?.setRowData([]);
        this.formModel.invoiceModel.expensesWithTax = true;
        this.onChangeSwitch(true)
        this.updateFooterRow();
      }else if ((this.commonVoucherModel?.voucherTypeId == VoucherType.PurchaseFixingDirectInvoice ||this.commonVoucherModel?.voucherTypeId == VoucherType.SaleFixingDirectInvoice) && this.gridApiFixingDirect) {
        this.gridApiFixingDirect?.api?.setRowData([]); 
      }
    }
    if(this.commonVoucherModel?.voucherTypeId == VoucherType.PurchaseFixingDirectInvoice ||this.commonVoucherModel?.voucherTypeId == VoucherType.SaleFixingDirectInvoice) {
    switch (this.commonVoucherModel?.voucherTypeId) {
      case  VoucherType.PurchaseFixingDirectInvoice:
        this.formModel.invoiceModel.againstVoucherTypeId =VoucherType.SalesInvoice;
        break;
      case VoucherType.SaleFixingDirectInvoice:
      this.formModel.invoiceModel.againstVoucherTypeId=VoucherType.PurchaseInvoice;
        break;
    }
  }
    
    this.getAllSettingTypes();
    this.fillAccountLedgerDropdown();
  }

  loadVoucherTypeWiseData(response) {
    this.formModel.invoiceTaxDetail = response?.applicableOnInvoice?.map((x) => { return { taxId: x?.id, taxName: x?.name, active: true }; });
    this.metalSectionModel.voucherWiseData = response;
    if (this.metalSectionModel?.voucherWiseData?.allMetalList?.length == 0 && (this.commonVoucherModel?.showMetalSection == true || this.commonVoucherModel?.showMetalSectionSimple == true) && this.formModel?.invoiceModel?.voucherTypeId !== VoucherType.StockTransfer) {
      this.notificationService.confirmationPopup('Configure Metals', "Metals are not set for " + this.commonVoucherModel?.voucherType, 'clear-data', false, "GO TO SETTING").subscribe((result) => {
        if (result?.isConfirmed) {
          this.storageService.store(StorageName.STORED_VOUCHERTYPE_FOR_UPDATE_METALS, { id: this.formModel?.invoiceModel?.voucherTypeId, route: this.commonVoucherModel?.route });
          this.router?.navigate(['/settings/voucher-type']);
        }
      });
    }
    else {
      // this.commonVoucherModel.disableMetalSection = false;
      if (this.commonVoucherModel?.showMetalSectionSimple == true)
        this.metalSectionChildComponent?.onTaxChangeResponse(response);
    }
    if (this.formModel?.invoiceTaxDetail == undefined || this.formModel?.invoiceTaxDetail?.length == 0)
      this.commonVoucherModel.showTaxSection = false;
    else
      this.taxSectionComponent?.addTaxColumns(this.formModel?.invoiceTaxDetail);
  }

  setVisibilityInstance() {
    this.totalSectionModel.setVisibility(this.commonVoucherModel?.formName);
    this.metalSectionModel.setVisibility(this.commonVoucherModel?.formName);
    this.paymentSectionModel.setVisibility(this.commonVoucherModel?.paymentGridName, this.commonVoucherModel?.enableAddStoneDiamond);
    this.itemSectionModel.setVisibility(this.commonVoucherModel?.formName);
    this.taxSectionModel.setVisibility(this.commonVoucherModel?.formName);
    this.paymentListSectionModel.setVisibility(this.commonVoucherModel?.formName);
    if (this.commonVoucherModel?.showExpensesWithTaxSwitch) {
      this.formModel.invoiceModel.expensesWithTax = true;
      this.agGridDataModelExpensesGrid = AgGridDataModelExpensesGrid;
    }
    this.agGridDataModelSalePurchaseFixingDirectGrid = AgGridDataModelSalePurchaseFixingDirectGrid;
  }

  setDefaultActiveMetalTab(defaultActiveMetalTab) {
    this.metalSectionModel.defaultActiveMetalTab = defaultActiveMetalTab;
  }
  //#endregion
  ngAfterViewInit(): void {
  }

  initializeData() {
    if (this.commonVoucherModel?.showAccountLedgerDropdown || this.commonVoucherModel?.isshowLayawaysDropdown) {
      const select2Element = this.elementRef?.nativeElement.querySelector('select2');
      select2Element.focus();
    }
    if (this.formModel?.invoiceModel?.id != undefined && this.formModel?.invoiceModel?.id != 0)
      this.getById();

    switch (this.commonVoucherModel?.voucherTypeId) {
      case VoucherType.SalesInvoice:
        const routeDataSaleOrder = this.storageService.retrieve(StorageName.STORED_SELECTED_SALESORDER_FORSALEINVOICE);
        if(routeDataSaleOrder){
          this.fillDataFromOtherResource(routeDataSaleOrder, VoucherType.SalesOrder, routeDataSaleOrder[0]?.accountLedgerId);
        }else{
         var dataFromOtherInvoices = this.storageService.retrieve(StorageName.STORED_DATA_FROM_OTHER_INVOICES);
         if(dataFromOtherInvoices && dataFromOtherInvoices?.id)this.fillDataForOtherInvoices(dataFromOtherInvoices?.id,dataFromOtherInvoices?.voucherTypeId);
        }
        break;
      case VoucherType.SalesOrder:
        const DataSaleOrder = this.storageService.retrieve(StorageName.STORED_SELECTED_NEWSALEORDER);
        if(DataSaleOrder) {
          this.fillDataFromOtherResource(DataSaleOrder, VoucherType.SalesOrder, DataSaleOrder[0]?.accountLedgerId);
        }else{
         var dataFromOtherInvoices = this.storageService.retrieve(StorageName.STORED_DATA_FROM_OTHER_INVOICES);
         if(dataFromOtherInvoices && dataFromOtherInvoices?.id)this.fillDataForOtherInvoices(dataFromOtherInvoices?.id,dataFromOtherInvoices?.voucherTypeId);
        }
        break;
      case VoucherType.ConsignmentIn:
        const routeDataConsignmentIn = this.storageService.retrieve(StorageName.STORED_SELECTED_MEMOREPORT_FORCONSIGNMENTIN);
        if (routeDataConsignmentIn != undefined)
          this.fillDataFromOtherResource(routeDataConsignmentIn, VoucherType.ConsignmentOut, routeDataConsignmentIn[0].accountLedgerId);
        break;
      case VoucherType.ConsignmentOut:
        const routeDataDiamondAndStoneStock = this.storageService.retrieve(StorageName.STORED_SELECTED_DIAMOND_STONE_STOCK);
        if (routeDataDiamondAndStoneStock != undefined)
          this.fillDataFromOtherResource(routeDataDiamondAndStoneStock);
        break;
      case VoucherType.BilOfMaterial:
        const routeDatabillOfmaterial = this.storageService.retrieve(StorageName.STORED_SELECTED_BILL_OD_MATERIAL);
        if (routeDatabillOfmaterial != undefined)
          this.fillDataFromOtherResource(routeDatabillOfmaterial);
        break;
      case VoucherType.JobworkInvoice:
        let invoiceItemsFromManufacturingProcess = this.storageService.retrieve(StorageName.STORED_JOBWORK_ITEMS_FORINVOICE);
        this.formModel.invoiceModel.jobworkOrderId = this.storageService.retrieve(StorageName.STORED_JOBWORK_ORDERID_FORRECEIVE);
        this.formModel.invoiceModel.id = this.storageService.retrieve(StorageName.STORED_JOBWORK_INVOICEID);
        if (this.formModel?.invoiceModel?.jobworkOrderId !== undefined && this.formModel?.invoiceModel?.jobworkOrderId !== 0) {
          this.fillDataForOtherInvoices(this.formModel?.invoiceModel?.jobworkOrderId, VoucherType.JobworkOrder);
        } else if (this.formModel?.invoiceModel?.id !== undefined && this.formModel?.invoiceModel?.id !== 0) {
          this.getById();
        } else if (invoiceItemsFromManufacturingProcess?.length > 0) {
          this.processDataForJobworkInvoice(invoiceItemsFromManufacturingProcess);
        }
        break;
      case VoucherType.JobworkOrder:
        setTimeout(() => {
          const routeData = this.storageService.retrieve(StorageName.STORED_SELECTED_SALESORDER);
          if (routeData != undefined) {
            this.fillFromSaleOrder(routeData);
            this.metalSectionComponent?.setColumnsVisible(undefined, false);
          }
        }, 300);
        break;
      case VoucherType.Appraisal:
        //  this.metalSectionComponent?.setColumnsVisible(undefined, false);
        break;
      case VoucherType.CatalogueQuotation:
        const DataCatalogueQuotation = this.storageService.retrieve(StorageName.STORED_SELECTED_CATALOGUE);
        if (DataCatalogueQuotation != undefined)
          this.fillDataFromOtherResource(DataCatalogueQuotation, VoucherType.CatalogueQuotation, DataCatalogueQuotation[0]?.accountLedgerId);
        break;
      case VoucherType.StockJournal:
        const stockJournalOption2Data = this.storageService.retrieve(StorageName.STORED_STOCKJOURNAL_OPTION2_DATA);
        if (stockJournalOption2Data?.isUpdateOldItemsForStockJournal){
          this.commonVoucherModel.showJournalVouchersPopupIcon = false;
          this.commonVoucherModel.showSaveInvoiceButton = false;
          this.metalSectionModel.moreButtonVisibility = false;
        }
        if (this.formModel?.invoiceModel?.id == undefined || this.formModel?.invoiceModel?.id == 0)
          this.fillFromStockJournalOption2StoredData(stockJournalOption2Data);
        break
    }
  }

  getProductDataByBarcodeNo(barcodeNo) {
    return new Promise((resolve, reject) => {
      if (barcodeNo)
        this.transactionService.getPrductByBarcodeNo(barcodeNo, this.formModel?.voucherType, this.formModel?.taxFromCustomer?.applicableOnProducts, this.formModel?.invoiceModel?.metalFix, this.formModel?.invoiceModel?.internalFix).subscribe({
          next: (res) => {
            if (res?.response?.detailedJson != '{"goldItem":[],"silverItem":[],"diamondItem":[],"stoneGemsItem":[],"imitationItem":[],"platinumItem":[]}')
              resolve(res?.response?.detailedJson);
            else resolve(null); // or resolve with default value
          }, error: (err) => { reject(err); }
        }); else resolve(null); // or resolve with default value
    });
  }

  getDistinctSum(data: any): number {
    const saleOrders: { [key: string]: number } = {};

    data.forEach(entry => {
      const { againstVoucherNo, advancePayment } = entry;
      // If sale order already exists, add the total amount to it
      if (saleOrders.hasOwnProperty(againstVoucherNo))
        saleOrders[againstVoucherNo] += advancePayment??0;
      else
        // If sale order is new, initialize it with the total amount
        saleOrders[againstVoucherNo] = advancePayment??0;
    });
    // Sum up the total amounts for distinct sale orders
    const distinctSum = Object.values(saleOrders).reduce((sum, amount) => sum + amount, 0);
    return distinctSum;
  }
  assignAccountLedgerId(accountLedgerId) {
    this.FilterData(accountLedgerId)
    const accountLedgerdata = this.getAllDropdownModel?.accountLedgerDropdown?.filter(x => Number(x.id) === Number(accountLedgerId));
    this.isHidePaymentSection = accountLedgerdata?.some(x => Number(x?.extra4) === Number(AccountGroupId?.CashInHand)) ?? false;
    this.formModel.invoiceModel.accountLedgerId = accountLedgerId == '' ? 0 : accountLedgerId;
    if (this.formModel.invoiceModel.accountLedgerId != '') {
      // this.formModel.invoiceModel.accountLedgerId= accountLedgerId;
      this.transactionService.getAccountLedgerBalanceReport(this.formModel?.invoiceModel?.accountLedgerId).pipe(catchError((err) => this.handleError(err))).subscribe((res) => {
        if (res?.isSuccess) {
          var balances = res?.response?.data;
          res.response.applicableOnProducts = res?.response?.applicableOnProducts?.filter(a => a?.entityType == this.commonVoucherModel?.customerTaxTypeName);
          res.response.applicableOnInvoice = res?.response?.applicableOnInvoice?.filter(a => a?.entityType == this.commonVoucherModel?.customerTaxTypeName);
          this.formModel.taxFromCustomer = res?.response;
          this.formModel.invoiceModel.fundTransferAmount = balances?.fundTransferAmount;
          this.formModel.amountBalance = (balances?.amountBalance == null ? 0 : balances?.amountBalance);
          this.formModel.balanceResult = "Balance Amount :- " + (balances?.amountBalance == null ? 0 : balances?.amountBalance) + ",  Gold : " + (balances?.goldBalance == null ? 0 : balances?.goldBalance) + ", Silver : " + (balances?.silverBalance == null ? 0 : balances?.silverBalance);
          this.formModel.amountBalance = (balances?.amountBalance == null ? 0 : balances?.amountBalance);
          this.formModel.goldBalance = (balances?.goldBalance == null ? 0 : balances?.goldBalance);
          this.formModel.silverBalance = (balances?.silverBalance == null ? 0 : balances?.silverBalance);
          if (this.formModel.invoiceModel.fundTransferAmount != 0)
            this.onFundTransfer(this.formModel);
          const filteredFundTransferArray = res?.response?.fundTransfer.filter(item => (item?.referenceInvoiceNo === null || item?.referenceInvoiceNo == this.formModel?.invoiceModel?.invoiceNo) && (item?.referenceVoucherNo === null || item?.referenceVoucherNo == this.formModel?.invoiceModel?.id) && (item?.referenceVoucherTypeId === null || item?.referenceVoucherTypeId == this.formModel?.invoiceModel?.voucherTypeId));
          this.formModel.fundTransfer = filteredFundTransferArray;
          this.formModel.invoiceModel.totalFundTransferAmount = this.formModel?.fundTransfer?.reduce((acc, item) => acc + item?.totalAmount, 0);
        }
      })
    } else {
      this.formModel.balanceResult = null;
      this.formModel.fundTransferAmountResult = null;
    }
    if (this.commonVoucherModel.showAgainstInvoiceDropdown)
    this.getAgainstData()
  }

  assignLayawaysId(schemeId) {
    this.formModel.invoiceModel.schemeId = schemeId == '' ? 0 : schemeId;
    this.layawaysDropdown.setDropdownText(this.formModel?.invoiceModel?.schemeId);
  }

  assignAgainstInvoiceNo(id) {
    this.formModel.invoiceModel.againstInvoiceNo = this.copiedAgainstDropdown?.find((x) => x?.id == id)?.name ?? "";
    this.formModel.invoiceModel.againstVoucherNo = Number(this.copiedAgainstDropdown?.find((x) => x.id === id)?.extra3 || 0);
    this.formModel.invoiceModel.againstVoucherTypeId = Number(this.copiedAgainstDropdown?.find((x) => x.id === id)?.extra1 || 0);
  }

  FilterData(accountLedgerId) {
    this.purchaseOrderNoDropdownFilterData = this.getAllDropdownModel?.purchaseOrderNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.saleOrderNoDropdownFilterData = this.getAllDropdownModel?.saleOrderNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.deliveryNoteNoDropdownFilterData = this.getAllDropdownModel?.deliveryNoteNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.saleQuotationNoDropdownFilterData = this.getAllDropdownModel?.saleQuotationNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.salesInvoiceNoDropdownFilterData = this.getAllDropdownModel?.saleInvoiceNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.purchaseInvoiceNoDropdownFilterData = this.getAllDropdownModel?.purchaseInvoiceNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.repairOrderNoDropdownFilterData = this.getAllDropdownModel?.repairOrderNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
    this.purchaseQuotationNoDropdownFilterData = this.getAllDropdownModel?.purchaseQuotationNoDropdown?.filter((x) => x?.extra1 == accountLedgerId);
  }


  getById() {
    this.transactionService.getInvoiceById(this.commonVoucherModel?.voucherTypeId, this.formModel?.invoiceModel?.id).subscribe(res => {
      if (res.isSuccess) {
        this.voucherTypeName = this.reportService.getVoucherTypeText(this.commonVoucherModel?.voucherTypeId.toString());
        this.formModel = res?.response;
        if (this.commonVoucherModel.voucherTypeId == VoucherType.StockJournal)
        {
          this.onGetByIdResponse.emit(res?.response);
          const stockJournalOption2Data = this.storageService.retrieve(StorageName.STORED_STOCKJOURNAL_OPTION2_DATA);
          if(stockJournalOption2Data.isUpdateOldItemsForStockJournal)
            this.formModel.isUpdateOldItemsForStockJournal = true;
        }

        if (this.commonVoucherModel.showExpensesWithTaxSwitch == true){
          this.gridApiExpenses?.api?.setRowData(this.formModel?.itemList);
          this.onChangeSwitch(this.formModel?.invoiceModel?.expensesWithTax);
        }if(this.commonVoucherModel.voucherTypeId == VoucherType.PurchaseFixingDirectInvoice ||this.commonVoucherModel?.voucherTypeId == VoucherType.SaleFixingDirectInvoice){
          this.gridApiFixingDirect?.api?.setRowData(this.formModel?.itemList);
          this.formModel.itemList.forEach((item)=>{
            var data = {data : item}
            this.addFooterAndCalculationForFixing(data);
          })
        }
        
        this.formModel.voucherType = this.commonVoucherModel?.voucherType;
        this.formModel.invoiceModel.voucherTypeId = this.commonVoucherModel?.voucherTypeId;
        this.invoiceDate = this.formModel?.invoiceModel?.invoiceDate;
        this.dueDate = this.formModel?.invoiceModel?.dueDate;
        if (this.commonVoucherModel.showAccountLedgerDropdown) {
          this.formModel.invoiceModel.accountLedgerId = this.formModel?.invoiceModel?.accountLedgerId?.toString();
          this.assignAccountLedgerId(this.formModel?.invoiceModel?.accountLedgerId);
        }
        if (this.commonVoucherModel.showVoucherTypeDropdown) {
          this.formModel.invoiceModel.againstVoucherTypeId = this.formModel?.invoiceModel?.againstVoucherTypeId?.toString() || 0;
          this.voucherTypeDropdown.setDropdownText(this.formModel?.invoiceModel?.againstVoucherTypeId);
        }
        if (this.commonVoucherModel.showAgainstInvoiceDropdown) {
          this.formModel.invoiceModel.againstInvoiceNo = this.formModel?.invoiceModel?.againstInvoiceNo ?? null;
          this.againstInvoiceDropdown.setDropdownText(this.formModel?.invoiceModel?.againstInvoiceNo);
        }
        // this.loadDropdownDataComponent.setInvoiceNo(this.formModel.invoiceModel.invoiceNo);
        this.loadDropdownDataComponent.getInvoiceNo(this.formModel?.invoiceModel?.invoiceNo)
        if (this.commonVoucherModel?.isshowLayawaysDropdown && this.formModel?.invoiceModel?.schemeId != undefined) {
          this.formModel.invoiceModel.schemeId = this.formModel?.invoiceModel?.schemeId?.toString();
          this.assignLayawaysId(this.formModel?.invoiceModel?.schemeId);
        }

        this.onExchangeRateChange(this.formModel?.invoiceModel?.exchangeRateId);
        // if (this.commonVoucherModel.showAgainstInvoiceDropdown && this.formModel?.invoiceModel?.againstVoucherTypeId != undefined)
        //   this.getAgainstData();
      }
    })
  }



  fillAccountLedgerDropdown() {
    this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);  // FOR LIST OF CUSTOMERES ADD
    this.getAllDropdownModel.accountLedgerDropdown = this.getAllDropdownModel?.accountLedgerDropdown;
    this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown);
  }

  allowedOptionsMap = {
    [VoucherType.SalesInvoice]: [AgainstOf.DeliveryNote, AgainstOf.SaleOrder, AgainstOf.SaleQuotation],
    [VoucherType.SalesQuotation]: [AgainstOf.DeliveryNote, AgainstOf.SaleOrder],
    [VoucherType.SalesReturn]: [AgainstOf.SalesInvoice, AgainstOf.SaleQuotation],
    [VoucherType.PurchaseReturn]: [AgainstOf.PurchaseInvoice, AgainstOf.PurchaseQuotation],
    [VoucherType.PurchaseQuotation]: [AgainstOf.PurchaseOrder],
    [VoucherType.PurchaseInvoice]: [AgainstOf.PurchaseOrder, AgainstOf.PurchaseQuotation],
    [VoucherType.RepairInvoice]: [AgainstOf.RepairOrder],
    [VoucherType.SalesOrder]: [AgainstOf.SaleQuotation],
  };

  fillDropdownData() {
    this.fillAccountLedgerDropdown();
    if (!this.isSalePersonDropdownInitialized) {
      this.getAllDropdownModel.salePersonDropdown = this.storageService.retrieve(StorageName.SALEPERSON_DROPDOWN);
      if(this.layoutDetails?.roleName === 'Sales Person'){
        this.formModel.invoiceModel.salePersonId = this.user?.id;
      }
      this.isSalePersonDropdownInitialized = true;
    }
    const againstofDropdown = this.storageService.retrieve(StorageName.AGAINST_OF_DROPDOWN);
    this.getAllDropdownModel.againstofDropdown = againstofDropdown?.filter(option =>option?.id == "0" || (this.allowedOptionsMap[this.commonVoucherModel?.voucherTypeId] || []).includes(Number(option?.id)));
    this.getAllDropdownModel.calculationDropdown = this.storageService.retrieve(StorageName.CALCULATION_DROPDOWN);
    this.getAllDropdownModel.saleOrderNoDropdown = this.storageService.retrieve(StorageName.SALEORDER_NO_DROPDOWN);
    this.getAllDropdownModel.saleQuotationNoDropdown = this.storageService.retrieve(StorageName.SALEQUOTATION_NODROPDOWN);
    this.getAllDropdownModel.purchaseQuotationNoDropdown = this.storageService.retrieve(StorageName.PURCHASEQUOTATIONNO_DROPDOWN);
    this.getAllDropdownModel.purchaseOrderNoDropdown = this.storageService.retrieve(StorageName.PURCHASEORDERNO_DROPDOWN);
    this.getAllDropdownModel.saleInvoiceNoDropdown = this.storageService.retrieve(StorageName.SALESINVOICE_NODROPDOWN);
    this.getAllDropdownModel.purchaseInvoiceNoDropdown = this.storageService.retrieve(StorageName.PURCHASEINVOICENO_DROPDOWN);
    this.getAllDropdownModel.deliveryNoteNoDropdown = this.storageService.retrieve(StorageName.DELIVERYNOTE_NODROPDOWN);
    this.getAllDropdownModel.barcodeToolBoxKeyDropdown = this.storageService.retrieve(StorageName.BARCODE_TOOLBOXKEYDROPDOWN);
    this.getAllDropdownModel.depositIntoDropdown = this.storageService.retrieve(StorageName.DEPOSIT_INTO_DROPDOWN);
    this.getAllDropdownModel.departmentDropdown = this.storageService.retrieve(StorageName.DEPARTMENT_DROPDOWN);
    this.getAllDropdownModel.userDropdown = this.storageService.retrieve(StorageName.USER_DROPDOWN);
    this.getAllDropdownModel.manufacturingUserDropdown = this.storageService.retrieve(StorageName.MANUFACTURING_USER_DROPDOWN);
    this.getAllDropdownModel.branchDropdown = this.storageService.retrieve(StorageName.BRANCH_DROPDOWN);
    this.getAllDropdownModel.againstDropdown = this.storageService.retrieve(StorageName.AGAINST_DROPDOWN);
    this.getAllDropdownModel.repairOrderNoDropdown = this.storageService.retrieve(StorageName.REPAIR_ORDERNO_DROPDOWN);
    this.getAllDropdownModel.fixingTypeDropdown = this.storageService.retrieve(StorageName.FIXING_TYPE_DROPDOWN);
     if (this.isBlankUndefinedOrNull(this.formModel?.invoiceModel?.fixingTypeId)) {
        const defaultOption = this.getAllDropdownModel.fixingTypeDropdown?.find(x => x?.id === FixingType.Standard.toString());
        if (defaultOption) {
          this.formModel.invoiceModel.fixingTypeId = defaultOption?.id;
        }
      }
    this.getAllDropdownModel.currencyExchangeDropdown = this.storageService.retrieve(StorageName.CURRENCY_EXCHANGE);
    if (this.commonVoucherModel?.showVoucherTypeDropdown){
      this.getAllDropdownModel.voucherTypeDropdown = this.storageService.retrieve(StorageName.VOUCHER_TYPE_DROPDOWN);
      this.voucherTypeDropdown?.setDataSource(this.getAllDropdownModel.voucherTypeDropdown);
    }
    //  if(this.commonVoucherModel.showAgainstInvoiceDropdown)
    //   this.getAllDropdownModel.againstDropdown = this.storageService.retrieve(StorageName.AGAINST_DROPDOWN);

    if (this.commonVoucherModel.voucherTypeId == VoucherType.JobworkOrder) {
      this.getAllDropdownModel.jobWorkPriorityDropdown = this.storageService.retrieve(StorageName.JOBWORK_PRIORITY_DROPDOWN);
      this.getAllDropdownModel.jobWorkPriorityDropdown.map((x) => x?.id == '0' ? x.id = '' : x?.id)
      this.getAllDropdownModel.jobWorkStatusDropdown = this.storageService.retrieve(StorageName.JOBWORK_STATUS_DROPDOWN);
      // this.getAllDropdownModel.jobWorkStatusDropdown.map((x) => x.id == '0' ? x.id = '' : x.id);
      this.getAllDropdownModel.jobWorkStatusDropdown = this.getAllDropdownModel?.jobWorkStatusDropdown?.filter((x) => x?.name != "Invoice Created");
      this.formModel.invoiceModel.statusId = JobWorkStatus.Processing.toString();
    }

    if (this.commonVoucherModel.voucherTypeId == VoucherType.ExpenseInvoice || this.commonVoucherModel?.voucherTypeId == VoucherType.IncomeInvoice)
      this.getAllDropdownModel.taxDropdown = this.storageService.retrieve(StorageName.TAX_DROPDOWN);
    
    this.getAllDropdownModel.metalDropdown = this.storageService.retrieve(StorageName.METAL_DROPDOWN);
    this.getAllDropdownModel.unitDropdown = this.storageService.retrieve(StorageName.UNIT_DROPDOWN);
    this.getAllDropdownModel.categoryDropdown  = this.storageService.retrieve(StorageName.CATEGORY_DROPDOWN); 
    this.getAllDropdownModel.calculationTypeDropdown = this.storageService.retrieve(StorageName.CALCULATION_TYPE_DROPDOWN);
    this.getAllDropdownModel.productDropdown = this.storageService.retrieve(StorageName.PRODUCT_DROPDOWN);
    this.getAllDropdownModel.cutDropdown = this.storageService.retrieve(StorageName.CUT_DROPDOWN);
    this.getAllDropdownModel.colorDropdown = this.storageService.retrieve(StorageName.COLOR_DROPDOWN);
    this.getAllDropdownModel.seiveSizeDropdown = this.storageService.retrieve(StorageName.SEIVE_SIZE_DROPDOWN);
    this.getAllDropdownModel.shapeDropdown = this.storageService.retrieve(StorageName.SHAPE_DROPDOWN);
    this.getAllDropdownModel.clarityDropdown = this.storageService.retrieve(StorageName.CLARITY_DROPDOWN);
    this.getAllDropdownModel.sizeDropdown = this.storageService.retrieve(StorageName.SIZE_DROPDOWN);
    this.getAllDropdownModel.udfDropdown = this.storageService.retrieve(StorageName.USERDEFINEFIELD_DROPDOWN);
    this.getAllDropdownModel.caratDropdown = this.storageService.retrieve(StorageName.CARAT_DROPDOWN);
    this.getAllDropdownModel.diamondCategoryDropdown = this.storageService.retrieve(StorageName.DIAMOND_CATEGORY_DROPDOWN);
    this.getAllDropdownModel.styleDropdown = this.storageService.retrieve(StorageName.STYLE_DROPDOWN);
    this.getAllDropdownModel.shapeCategoryDropdown = this.storageService.retrieve(StorageName.SHAPE_CATEGORY_DROPDOWN);
    this.metalSectionComponent?.initialCalls();
    this.metalSectionChildComponent?.loadDesignNoDropdown();
    this.paymentSectionComponent?.fillDropdownData();
    this.commonVoucherModel.disableMetalSection = false;
    this.initializeData();
    this.selectionCurrencyExchangeId();
   setTimeout(() => {
     this.getAllDropdownModel.schemeNameDropdown = this.storageService.retrieve(StorageName.SCHEME_NAME_DROPDOWN);
    this.layawaysDropdown?.setDataSource(this.getAllDropdownModel?.schemeNameDropdown);
   }, 0);
  }

  selectionCurrencyExchangeId() {
    const selectedItem = this.getAllDropdownModel?.currencyExchangeDropdown?.find(x => x?.extra4 == "1");
    this.selectedBaseCurrencyName = `${selectedItem?.extra2 || ''}`;

    this.formModel.invoiceModel.exchangeRateId = selectedItem ? selectedItem?.id : null;
    this.formModel.invoiceModel.currencyExchangeRate = selectedItem?.extra1 ? parseFloat(selectedItem?.extra1) : 0;
  }

  onExchangeRateChange(selectedId: any) {
    this.formModel.invoiceModel.exchangeRateId = selectedId;
    const selectedItem = this.getAllDropdownModel?.currencyExchangeDropdown?.find((x) => x?.id == selectedId);

    this.selectedCurrencyName = `${selectedItem?.extra2 || ''}`;
    this.formModel.invoiceModel.currencyExchangeRate = selectedItem?.extra1 ? parseFloat(selectedItem?.extra1) : 0;
    this.totalSectionComponent?.getCalculatedInvoiceDetails(this.formModel);
  }
  
  openCustomerDetailsSlider(type: string, ledgerName: string = ''): void {
    const accountLedgerId = type === 'Edit' ? this.formModel?.invoiceModel?.accountLedgerId : 0;
    const data = {
      accountLedgerId: accountLedgerId,
      SundryType: this.commonVoucherModel?.sundryType,
      ledgerName: ledgerName,
    };

    this.notificationService.openSlider(CustomerDetailsComponent, data).then(
      (result) => {
        if (result) {
          this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);
          const newLedger = this.getAllDropdownModel?.accountLedgerDropdown?.filter((x) => x?.id === result.toString())[0];
          this.formModel.invoiceModel.accountLedgerId = newLedger?.id;
          this.customSelect2Component?.setNewLedgerName(newLedger?.name)
          this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown, newLedger?.id);
          this.customSelect2Component.setDropdownText(newLedger?.id);
          this.assignAccountLedgerId(this.formModel?.invoiceModel?.accountLedgerId)
        }
      });
  }

  OpenCreateUpdateSchemeSlider(type: string) {
    // Pass data to the component instance
    const schemeId = type === 'Update' ? this.formModel?.invoiceModel?.schemeId : 0;
    const data = { schemeType: type, schemeId: schemeId };

    this.notificationService.openSlider(CreateSchemeComponent, data).then(
      (result) => {
        if (result) {
          this.agGridService?.getDropdownByStorageName(StorageName.SCHEME_NAME_DROPDOWN).subscribe({
            next: (res) => {
              this.getAllDropdownModel.schemeNameDropdown = res?.response ?? [];
              this.storageService.store(StorageName.SCHEME_NAME_DROPDOWN, this.getAllDropdownModel?.schemeNameDropdown);
              if (this.getAllDropdownModel.schemeNameDropdown?.length) this.layawaysDropdown?.setDataSource(this.getAllDropdownModel?.schemeNameDropdown);
            }
          });
        }
      })
  }

  openWithReaderDetailsPopup(type: string, ledgerName: string = ''){
  
    if (this.ipcService.isRunningInElectron) {
      
      this.ipcService.send('GetCardReaderData');
      this.ipcService.once('ReaderInfo', (event, rawData) => {
        if (!rawData.startsWith('0') ||rawData=='' ) {         
        this.notificationService.errorPopup(rawData);
        }
          let jsonData = rawData.substring(2);
          jsonData = jsonData.replace(/\\/g, '\\\\'); // Replace single backslashes with double backslashes
          var parsedData : any = {}
          try {
            parsedData = JSON.parse(jsonData);
             // Now you can access the parsed data
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
          var country=this.storageService.retrieve(StorageName.COUNTRY_DROPDOWN).filter(a=>a?.name==parsedData?.nationalityEnglish)[0];
          this.convertImageToBase64(parsedData?.CardHolderPhoto)
              .then((base64) => {
              var data = {
                accountLedgerId : type === "Edit" ? this.formModel?.invoiceModel?.accountLedgerId : 0,
                SundryType : this.commonVoucherModel?.sundryType,
                ledgerName : parsedData?.Name,
                mobile : parsedData?.Mobile?.replace(/^971/, ''),
                aadhaarCardNo : parsedData?.PassportNumber,
                pan : parsedData?.CivilID,
                email : parsedData?.Email,
                dateOfBirth : parsedData?.DOB,
                addressLine1 : parsedData?.Address,
                imageUrl : base64,
                fromReader : true ,
                id : 0,
                regionOfResidentId:country?.id,
                nationalityId:country?.id
              }

              this.notificationService.openSlider(CustomerDetailsComponent, data).then(
                (result) => {
                if (result) {
                  this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);
                  const newLedger = this.getAllDropdownModel?.accountLedgerDropdown?.filter((x) => x?.id === result.toString())[0];
        
                  this.formModel.invoiceModel.accountLedgerId = result.toString();
                  this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown, newLedger?.id);
                }
              });
            })
            .catch((error) => {
              console.error('Error loading image:', error);
            });
      });
    }
  }

  fillDataFromOtherResource(data, againstVoucherTypeId = undefined, accountLedgerId = undefined) {
    this.formModel.itemList = data;
    this.formModel.invoiceModel.accountLedgerId = accountLedgerId;

    (async () => {
      for (const element of this.formModel.itemList) {
        var detailedJson: any = await this.getProductDataByBarcodeNo(element?.barcodeNo);
        const detailedJsonParseData = JSON?.parse(detailedJson);
        const previousDetailedJson = element?.detailedJson != undefined ? JSON.parse(element?.detailedJson) : undefined;
        var getSaleInvoiceItemsDetailsModel: any = {};
        getSaleInvoiceItemsDetailsModel.isMelting = this.formModel.invoiceModel.isMelting;
        getSaleInvoiceItemsDetailsModel.parentMetalId = this.metalSectionModel.parentMetalId;
        getSaleInvoiceItemsDetailsModel.goldItem = detailedJsonParseData?.goldItem.length > 0 ? detailedJsonParseData?.goldItem : previousDetailedJson?.goldItem;
        getSaleInvoiceItemsDetailsModel.silverItem = detailedJsonParseData?.silverItem.length > 0 ? detailedJsonParseData?.silverItem : previousDetailedJson?.silverItem;
        getSaleInvoiceItemsDetailsModel.diamondItem = detailedJsonParseData?.diamondItem.length > 0 ? detailedJsonParseData?.diamondItem : previousDetailedJson?.diamondItem;
        getSaleInvoiceItemsDetailsModel.imitationItem = detailedJsonParseData?.imitationItem.length > 0 ? detailedJsonParseData?.imitationItem : previousDetailedJson?.imitationItem;
        getSaleInvoiceItemsDetailsModel.itemList = this.formModel?.itemList;
        getSaleInvoiceItemsDetailsModel.invoiceTaxDetail = this.formModel?.invoiceTaxDetail;
        getSaleInvoiceItemsDetailsModel.voucherTypeId = this.formModel?.invoiceModel?.voucherTypeId;
        getSaleInvoiceItemsDetailsModel.comment = detailedJsonParseData?.comment;
        getSaleInvoiceItemsDetailsModel.groupName = detailedJsonParseData?.groupName;
        getSaleInvoiceItemsDetailsModel.isGroup = getSaleInvoiceItemsDetailsModel?.groupName === "" ? false : true;
        getSaleInvoiceItemsDetailsModel.invoiceItemImageResources = detailedJsonParseData?.invoiceItemImageResources ?detailedJsonParseData?.invoiceItemImageResources:previousDetailedJson?.invoiceItemImageResources;
        this.transactionService.getInvoiceItemWithDescription(getSaleInvoiceItemsDetailsModel,)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res: ResponseModel) => {
            var responseOfCompleteItem = res?.response;
            element.grossWt = responseOfCompleteItem?.grossWt;
            element.finalWt = responseOfCompleteItem?.finalWt;
            element.alloyWt = responseOfCompleteItem?.alloyWt;
            element.description = responseOfCompleteItem?.description;
            element.metalValue = responseOfCompleteItem?.metalValue;
            element.amount = responseOfCompleteItem?.amount;
            element.netAmount = responseOfCompleteItem?.netAmount;
            element.netAmountWithTax = responseOfCompleteItem?.netAmountWithTax;
            element.parentMetalId = responseOfCompleteItem?.parentMetalId;
            element.detailedJson = responseOfCompleteItem?.detailedJson;
            element.againstVoucherTypeId = againstVoucherTypeId;
            element.againstVoucherNo = element?.id;
            this.formModel.invoiceModel.saleOrderAdvancePayment = this.textProcessingService?.fixAmountDecimal((data[0]?.voucherTypeId == VoucherType.SalesOrder || data[0]?.voucherTypeId == VoucherType.PurchaseOrder  )? this.getDistinctSum(this.formModel?.itemList) : 0);
            this.formModel.invoiceModel.advancePayment = this.getDistinctSum(this.formModel?.itemList);
            this.formModel.invoiceModel.accountLedgerId = accountLedgerId;
            if(this.formModel?.invoiceModel?.accountLedgerId) this.FilterData(this.formModel?.invoiceModel?.accountLedgerId);
            this.callCalculationAfterItemListProcessed();
          });
      }
    })();
  }

  callCalculationAfterItemListProcessed() {
    setTimeout(() => {
      this.storageService?.getInvoice.next({ response: { itemList: this.formModel.itemList } });
      this.storageService?.setSelect2Dropdown.next(this.formModel?.invoiceModel?.accountLedgerId);
      this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown, this.formModel?.invoiceModel?.accountLedgerId?.toString());
      this.totalSectionComponent?.getCalculatedInvoiceDetails(this.formModel, "");
    }, 100);
  }

  setItemList(data, selectedRow?) {
    this.formModel.invoiceModel.againstVoucherNo = selectedRow?.id;
    this.formModel.invoiceModel.againstVoucherTypeId = selectedRow?.voucherTypeId;
    this.formModel.invoiceModel.againstInvoiceNo = selectedRow?.invoiceNo;
    this.formModel.itemList = data;
    setTimeout(() => {
      this.storageService?.getInvoice?.next({ response: { itemList: this.formModel?.itemList } });
      if ((data[0]?.againstVoucherTypeId == VoucherType.SalesOrder || data[0]?.againstVoucherTypeId == VoucherType.PurchaseOrder)) this.calAdvancePayment();
      this.totalSectionComponent?.getCalculatedInvoiceDetails(this.formModel, "")
    }, 100);
  }

  calAdvancePayment(){
    this.formModel.invoiceModel.saleOrderAdvancePayment = (this.textProcessingService.fixAmountDecimal(this.getDistinctSum(this.formModel?.itemList)))??0;
    this.formModel.invoiceModel.advancePayment = this.getDistinctSum(this.formModel?.itemList);
  }

  onDeleteExpense() {
    var expensesDetailsData = this.gridApiExpenses?.api?.getModel()?.rowsToDisplay?.map(a => a?.data);
    expensesDetailsData.forEach(element => {
      element.taxId = (this.formModel?.invoiceModel?.expensesWithTax) ? element?.taxId : 0;
      element.taxAmount = (this.formModel?.invoiceModel?.expensesWithTax) ? element?.taxAmount : 0;
      element.netAmountWithTax = (this.formModel?.invoiceModel?.expensesWithTax) ? element?.netAmountWithTax : element?.amount;
    });
    const newData = this.gridApiExpenses?.api?.getModel()?.rowsToDisplay?.map(a => a?.data)
    this.setItemList(newData);
    if (this.gridApiExpenses) {
      this.updateFooterRow();
    }
  }
  //#endregion
  onCellKeyDownValue(event?: any) {
    switch (event.dataModel.storageName) {
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
        this.onKeydown(event?.gridOptions?.event, 'addButton');
        return;
        // this.agGridService.setFocusToLastRow(this.paymentSectionComponent.gridApi);
        break;
      case "FORMNAME_TRANSACTION_SALESINVOICE_PAYMENT_TABLE":
        this.onKeydown(event?.gridOptions?.event, 'save_invoice');
        break;
    }
  }
  onfocus(event, id) {
    const elm = document.getElementById(id) as HTMLInputElement;
    elm.focus();
    elm.select();
  }

  onItemListChange(formModel) {
    if (this.commonVoucherModel.showMetalSectionSimple != true)
      this.metalSectionComponent.metalSectionModel.barcodeNo = '';
    this.calAdvancePayment();
    this.formModel.invoiceModel.ounceRate = this.textProcessingService.fixAmountDecimal(this.formModel?.invoiceModel?.ounceRate == "" ? "0" : this.formModel?.invoiceModel?.ounceRate );
    this.totalSectionComponent?.getCalculatedInvoiceDetails(formModel);
    this.onItemListChangeResponse.emit(formModel);
  }
  onFundTransfer(formModel) {
    this.totalSectionComponent?.getCalculatedInvoiceDetails(formModel);
  }
  onItemListRowClick(itemListRowData) {
    this.openMetalSectionPopup(itemListRowData);
  }

  onDeleteItemClick(itemListRowData) {
    this.onDeleteItemClickResponse.emit(itemListRowData);

    if(this.formModel?.voucherType == VoucherTypeName.StockTransferOut || this.formModel?.voucherType == VoucherTypeName.StockTransferIn){
      this.deletestocktransferinoutitems(itemListRowData?.data)
    }
  }

  deletestocktransferinoutitems(data) {
    const requestData = { id: data?.id, voucherTypeId: this.formModel?.invoiceModel?.voucherTypeId }
    this.transactionService.deletestocktransferinoutitems(requestData).subscribe({
      next: (res) => {
        this.toaster.success(res?.message);
      },
      error: (err) => {

      }
    })
  }
  

  onEditPaymentClicked(id) {
    this.formModel.invoiceModel.id = id;
    this.getById();
  }


  //#endregion 
  //#region getCalculatedInvoiceDetails

  onGetCalculatedInvoiceDetails(response) {
    this.formModel.invoiceModel = response?.invoiceModel;
  }


  newInvoice() {
    this.notificationService.confirmationPopup('New Invoice', "Are you sure want to clear Data?", 'clear-data').subscribe((result) => {
      if (result?.isDismissed) {
      } else if (result?.isConfirmed) {
        this.resetInvoice();
        if(this.paymentSectionComponent)this.paymentSectionComponent.clearBarcode();
      } else if (result?.isDenied) {
      }
    })
  }

  //#endregion

  //#region generate sale invoice
  onSave() {
    if (!(this.formModel?.invoiceModel?.id ? this.commonVoucherModel?.invoiceCanUpdate : this.commonVoucherModel?.invoiceCanAdd)) {
      return;
    }
  
    const isNewInvoice = this.isBlankUndefinedOrNull(this.formModel?.invoiceModel?.id);
    this.formModel.invoiceModel.sendNotification = isNewInvoice;
    this.formModel.issueTaxRefundTransaction = false;
  
    const currentTime = this.invoiceDateComponent.getCurrentTime();
    this.formModel.invoiceModel.invoiceDate = `${this.invoiceDate?.split('T')[0]}T${currentTime}`;
    
    if (this.dueDate)
      this.formModel.invoiceModel.dueDate = `${this.dueDate.split('T')[0]}T${currentTime}`;
  
    if (!this.commonVoucherModel?.showTopSection) {
      this.loadDropdownDataComponent.confirmPrintPopUp();
      return;
    }
  
    switch (this.commonVoucherModel?.voucherTypeId) {
      case VoucherType.SalesReturn:
        this.OnConfirmBarcodePrintPopup();
        break;
      case VoucherType.SalesInvoice:
        if (isNewInvoice && this.formModel?.checkPlanetConfiguration) {
          this.notificationService.confirmationPopup(
            "Tax Refund Transaction",
            "Are you sure you want to issue a new tax refund transaction for this existing invoice?",
            'printBill'
          ).subscribe((result) => {
            if (result.isConfirmed)
              this.formModel.issueTaxRefundTransaction = true;
            this.loadDropdownDataComponent?.confirmPrintPopUp();
          });
        } else this.loadDropdownDataComponent?.confirmPrintPopUp();
        break;
      default:
        this.loadDropdownDataComponent?.confirmPrintPopUp();
        break;
    }
  }
  

  OnConfirmBarcodePrintPopup() {
    const data = { isBarcodePrintpoup: true };
    this.notificationService?.openModalPopup(ConfirmationPopUPComponent, data, undefined, ModalPopupSize.SM)
      .then((result) => {
        this.formModel.generateBarcode = result === true;
        this.loadDropdownDataComponent.confirmPrintPopUp();
      });
  }
  
  onPrint(isPrint) {
    this.formModel.isPrint = isPrint;
    this.processToInsertInvoiceData();
  }
  //#endregion
  
  processToInsertInvoiceData() {
    const voucherTypeId = this.formModel?.invoiceModel?.voucherTypeId;
  
    this.transactionService.getSettingsAndRDLCTemplate(this.formModel?.isPrint, null, voucherTypeId, (printFormatData) => {
      if (printFormatData) {
        this.openSelectPrintFormatPopup(printFormatData);
      } else {
        this.addInvoice();
      }
    });
  }
  
  openSelectPrintFormatPopup(printFormatData: any){
   var data = {printFormatData : printFormatData, modalTitle : 'Select Print Format'}
   this.notificationService.openModalPopup(SelectPrintFormatPopupComponent,data,undefined,ModalPopupSize.MD,'',false,true).then(
    (result)=>{
      if (result) {
        const componentInstance = result?.componentInstance;
        this.rdlcResourceName = componentInstance?.rdlcResourceName;
        this.addInvoice();
      }
    }
   )
  }

  // #endregion 

  resetInvoice() {
    this.storageService.store(this.commonVoucherModel?.invoiceIdName, 0);
    this.storageService.resetInvoice.next(this.commonVoucherModel?.controllerName);
    this.initialCalls(this.formModel?.invoiceModel);
    this.metalSectionModel.comment = null;
    this.metalSectionModel.groupName = null;
    this.metalSectionModel.barcodeNo = "";
    this.metalSectionModel.productCode = "";
    this.formModel.invoiceModel.againstInvoiceNo = "";
    this.formModel.invoiceModel.againstVoucherNo = 0;
    this.paymentSectionComponent?.clearBarcode();
    this.invoiceDateComponent?.getupdateCurrentDate();
    this.dueDateComponent?.getupdateCurrentDate();
    this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown, 0);
    this.customSelect2Component?.reset();
    this.customSelect2Component?.setDropdownText("");
    this.formModel.invoiceModel.accountLedgerId = 0;
    this.layawaysDropdown?.setDataSource(this.getAllDropdownModel?.schemeNameDropdown, 0);
    this.layawaysDropdown?.reset();
    this.layawaysDropdown?.setDropdownText("");
    this.voucherTypeDropdown?.setDataSource(this.getAllDropdownModel?.voucherTypeDropdown);
    this.voucherTypeDropdown?.reset();
    this.voucherTypeDropdown?.setDropdownText("");
    this.againstInvoiceDropdown?.setDataSource([]);
    this.againstInvoiceDropdown?.reset();
    this.againstInvoiceDropdown?.setDropdownText("");
    this.formModel.invoiceModel.schemeId = 0;
    this.rdlcResourceName = "";
    this.storageService.customDropdownValue.next(this.ledgerName);
    this.ledgerName='';
    this.metalSectionComponent?.resetdesignNoDropdown();
    this.commonCommentComponent.comments = [];
    this.commonCommentComponent.addeditComment.comment = '';
    this.fileName = "";
    this.selectedFile = null;
    if (this.commonVoucherModel.voucherTypeId == VoucherType.JobworkOrder) {
      this.formModel.invoiceModel.statusId = JobWorkStatus.Processing.toString();
    }
    if(this.layoutDetails?.roleName === 'Sales Person'){
      this.formModel.invoiceModel.salePersonId = this.user?.id;
    }
    this.customSelect2Component.setNewLedgerName(null);
  }

  addInvoice() {
    this.transactionService.insertInvoice(this.formModel, this.commonVoucherModel?.invoiceIdName, this.commonVoucherModel?.controllerName).pipe(catchError((err) => this.handleError(err))).subscribe((res: ResponseModel) => {
      if (res.isSuccess) {
        this.toaster.success(res.message);
        if (this.formModel.issueTaxRefundTransaction && this.formModel?.invoiceModel?.voucherTypeId === VoucherType.SalesInvoice) {
          if (res?.errors?.length > 0) {
            var errorMsg = res?.errors?.join('\r\n');
            this.notificationService?.errorPopup(errorMsg);
          }
        }

        this.onInsertInvoiceResponce.emit(res);
        this.paymentListComponent?.getAllVoucherData();
        this.sendDataService.checkRedirectUrlAfterSave();
        var result = this.reportService.processResponse(res, this.formModel?.invoiceModel, this.notificationConfigurationModel, this.formModel?.isPrint, undefined, this.rdlcResourceName, true)
        if (((this.formModel?.invoiceModel?.voucherTypeId === VoucherType.JobworkInvoice) || (this.formModel?.invoiceModel?.voucherTypeId === VoucherType.JobworkOrder))
          && result?.response?.invoiceModel?.statusId === JobWorkStatus.Completed.toString()) {
          this.formModel.invoiceModel.notificationTemplateName = 'SaleOrderCompletedTemplate';
          this.reportService.processResponse(res, this.formModel?.invoiceModel, this.notificationConfigurationModel, false)
        }

        this.resetInvoice();
      }
      else {
        this.formModel.invoiceModel.id = res?.response;
        this.formModel.invoiceModel.createdBy = this.storageService.retrieve(StorageName.USER_INFO)?.id;
      }
    });
  }

  //#endregion

  deleteRows(params) {
    params.data.deleted = true;
    params.data.added = false;
    params.data.edited = false;
    params.data.none = false;
  }

  ngOnDestroy() {
    this.storageService.removeItem(StorageName.STORED_SELECTED_BILL_OD_MATERIAL);
    this.storageService.removeItem(this.commonVoucherModel?.invoiceIdName);
    this.storageService.removeItem(StorageName.STORED_SELECTED_MEMOREPORT_FORCONSIGNMENTIN);
    this.storageService.removeItem(StorageName.STORED_SELECTED_SALESORDER_FORSALEINVOICE);
    this.storageService.removeItem(StorageName.STORED_SELECTED_SALESORDER);
    this.storageService.removeItem(StorageName.STORED_SELECTED_CATALOGUE);
    this.storageService.removeItem(StorageName.STORED_PRODUCTDETAILID_FOR_FIXING);
    this.storageService.removeItem(StorageName.STORED_SALE_INVOICE_DATA);
    this.storageService.removeItem(StorageName.STORED_JOBWORK_INVOICEID);
    this.storageService.removeItem(StorageName.STORED_PURCHASE_INVOICE_DATA);
    this.storageService.removeItem(StorageName.STORED_JOBWORK_ORDERID_FORRECEIVE);
    this.storageService.removeItem(StorageName.STORED_JOBWORK_ITEMS_FORINVOICE);
    this.storageService.removeItem(StorageName.STORED_SELECTED_DIAMOND_STONE_STOCK);
    this.storageService.removeItem(StorageName.STORED_SELECTED_NEWSALEORDER);
    this.storageService.removeItem(StorageName.STORED_SALE_ORDER_ACCOUNTLEDGERID);
    this.storageService.removeItem(StorageName.STORED_DATA_FROM_OTHER_INVOICES);
    this._onTabKeyPressedSubscription?.unsubscribe();
    this.sendDataService.headerPageNameAndInvoiceNum.next(undefined);
    this._onSaveAsDraftBeforeCloseSubscription?.unsubscribe();
    if (this._onSaveBeforeCloseSubscription) {
      this._onSaveBeforeCloseSubscription.unsubscribe();
    }
    this.invoiceNoCalled?.unsubscribe();
    if (this.resetInvoiceSubscription) {
      this.resetInvoiceSubscription.unsubscribe();
    }
    this.navigationThroughInvoiceNo?.unsubscribe();
  }
  confirmedDocuments(imageList) {
    this.formModel.invoiceDocumentResources = imageList;
  }


  stateWiseTaxList(accountLedgerId) {
    this.taxSectionComponent.loadStatewiseTaxList(accountLedgerId);
  }

  selectedRangeDates(event?: any) {
    // this.formModel.invoiceModel.invoiceDate = event;
    this.invoiceDate = event;
  }
  //#region Popups


  //#endregion

  // onkeydown method focus next input start
  onKeydown(event: KeyboardEvent | any, nextElement: string, previousElement?: string) {
    // event.preventDefault();
    if (event?.key === 'Tab') {
      // event.preventDefault();
      // let element = document.getElementById(nextElement) as any;
      // element?.focus();
    }
    else if (event?.key === 'Backspace' && event.shiftKey) {
      // event.preventDefault();
      // let element = document.getElementById(previousElement);
      // element?.focus();
    }
    else if (event?.key === 'Enter') {
      event?.preventDefault();
      let element = document.getElementById(nextElement) as any;
      if (event?.srcElement?.nodeName == 'SELECT') {
        if (event?.target?.value) {
          if (element?.nodeName == 'SELECT') {
            element?.focus();
            element?.showPicker()
          } else {
            element?.focus();
          }
        } else {
          event?.srcElement?.focus();
          event?.srcElement?.showPicker()
        }
      } else {
        element?.focus();
      }
    }
  }
  // onkeydown method focus next input end

  checkPresentInLedgerList(ledgerName) {
    let element = document.getElementById('referenceNo') as any;
    if (ledgerName) {
      this.openCustomerDetailsSlider('Add', ledgerName);
      this.ledgerName =ledgerName;
      element?.blur(); 
    }
    else {
      element?.focus();
      element?.showPicker();
    }
  }

  SendDataToItemList(event) {
    
    this.sampleFileData = event;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: any): void {
    const targetElement = event?.target;
    if (targetElement?.tagName === 'INPUT' || targetElement?.tagName === 'TEXTAREA') return;
    
    if (event.location === KeyboardEvent.DOM_KEY_LOCATION_NUMPAD) {
      
    }
    if (event?.ctrlKey) {
      switch (event?.keyCode) {
      }
    } else if (event?.shiftKey) {
      switch (event?.keyCode) {
        // metal section tabs start
        case (KeyCode.Key1):
          this.metalTabClickOnShortCutKeys(event, 1)
          break;
        case (KeyCode.Key2):
          this.metalTabClickOnShortCutKeys(event, 2)
          break;
        case (KeyCode.Key3):
          this.metalTabClickOnShortCutKeys(event, 4)
          break;
        case (KeyCode.Key4):
          this.metalTabClickOnShortCutKeys(event, 6)
          break;
        case (KeyCode.Key5):
          this.metalTabClickOnShortCutKeys(event, 5)
          break;
        // metal section tabs start
        case (KeyCode.N):
          event.preventDefault();
          if (!this.modalService.hasOpenModals()) {
            this.getHtmlElementAndPerformAction(event, 'newInvoice');
          }
          break;
        case (KeyCode.S):
          event.preventDefault();
          if (!this.modalService.hasOpenModals()) {
            this.getHtmlElementAndPerformAction(event, 'save_invoice');

          }
          break;
        case (KeyCode.A):
          this.getHtmlElementAndPerformAction(event, 'addButton');

          break;
        case (KeyCode.I):
          event.preventDefault();
          const uploadItemIconElement = document?.getElementById('uploadItemImages') as HTMLElement | any;
          uploadItemIconElement?.classList?.contains('pointer_none') ? null : uploadItemIconElement?.firstElementChild?.click();
          break;
        case (KeyCode.P):
          this.getHtmlElementAndPerformAction(event, 'addMorePaymentBtn');
          break;
        case (KeyCode.M):
          event.preventDefault();
          const metalSectionTabs = document?.querySelectorAll('.nav-item') as any;
          
          let activeTabItem: any = undefined;
          metalSectionTabs?.forEach((item) => {
            if (item?.firstElementChild?.classList?.contains('active')) {
              activeTabItem = item;
              return
            }
          });
          this.getHtmlElementAndPerformAction(event, `${activeTabItem?.firstElementChild?.innerText}AddMoreItemBtn`);
          break;
      }
    }
  }

  metalTabClickOnShortCutKeys(event, metalTabId) {
    event?.preventDefault();
    const navTabActiveElement = document.getElementById(MetalSectionNavTab + metalTabId) as any;
    navTabActiveElement?.firstElementChild?.click();
    navTabActiveElement?.firstElementChild?.focus();
  }

  getHtmlElementAndPerformAction(event, elementId) {
    event?.preventDefault();
    const buttonElement = document.getElementById(elementId) as HTMLElement | any;

    if (!buttonElement?.classList?.contains('pointer_none')) {
      buttonElement?.click();
    }
  }

  //#region Sale Invoice Only

  onAgainstOfChange(selectedValue: any) {
    const disabledOptions: any = this.customSelect2Component?.id ? [] : ['1', '2', '3', '4', '5', '6', '7', '8'];
    if (disabledOptions.includes(selectedValue)  || selectedValue === '0') {
      this.formModel.invoiceModel.againstOfId = null
      return;
    }
    this.formModel.invoiceModel.againstOfId = selectedValue;
     this.dropdownFilterData();
  }
  dropdownFilterData(){
    const ResponseModel = {againstOfId : this.formModel?.invoiceModel?.againstOfId,accountLedgerId  :this.formModel?.invoiceModel?.accountLedgerId}
    this.transactionService.getAgainstofDropdowns(ResponseModel).subscribe((res) => {
      if (res.isSuccess) {
        this.openAgainstOfPopup(res?.response);
      }
    })
  }
  openAgainstOfPopup(response) {
    let data = {
      againstOfId: this.formModel?.invoiceModel?.againstOfId,
      accounLedgetId: this.formModel?.invoiceModel?.accountLedgerId,
      againstofDropdownFilterData: response?.againstOfDropdown,
      againstVoucherNo: this.formModel?.invoiceModel?.againstVoucherNo,
      againstVoucherTypeId: this.formModel?.invoiceModel?.againstVoucherTypeId,
      voucherTypeId:this.formModel?.invoiceModel?.voucherTypeId,
    }
    this.notificationService.openModalPopup(AgainstOfPopupComponent, data, undefined, ModalPopupSize.LG, '', false, true).then(([itemList, selectedRow]) => {
      if (itemList) {
        this.updateArrayWithAdvancePayment(itemList, this.saleOrderNoDropdownFilterData)
        this.setItemList(itemList, selectedRow);
      }
    })
  }

  updateArrayWithAdvancePayment(itemList, saleOrderNoDropdownFilterData) {
    const usedOrderNo = new Set(); // To track processed vouchers.
    for (const item of itemList) {
      if (!usedOrderNo?.has(item?.orderNo)) {
        const match = saleOrderNoDropdownFilterData?.find(el => el?.name === item?.orderNo);
        if (match) {
          item.advancePayment = match?.extra2 ? Number(match?.extra2): 0 ; // Update the original object.
          usedOrderNo?.add(item?.orderNo); // Mark this voucher as used.
        }
      }
    }
  }
 
  //#endregion

  //#region Material Issue / Material Receive
  updateAccountLedgerDropdownSource(departmentId) {
    var toUserList = [];
    this.formModel.invoiceModel.departmentId = (departmentId == '' || departmentId == undefined) ? '0' : departmentId;
    if (departmentId == '' || departmentId == undefined || departmentId == null)
      toUserList = this.getAllDropdownModel?.accountLedgerDropdown;
    else if (departmentId) {

      toUserList = this.getAllDropdownModel?.manufacturingUserDropdown?.filter(a => {
        let extra1Array = JSON?.parse(a.extra1);
        return extra1Array.includes(Number(this.formModel?.invoiceModel?.departmentId));
      });
    }
    if (toUserList?.length > 0) {
      const foundUser = toUserList?.find(user => user?.id == this.formModel?.invoiceModel?.accountLedgerId);
      if (foundUser) {
        this.formModel.invoiceModel.accountLedgerId = foundUser?.id;
      } else {
        this.formModel.invoiceModel.accountLedgerId = toUserList[0]?.id?.toString() ?? '';
      }
    }
    this.customSelect2Component.setDataSource(toUserList, this.formModel?.invoiceModel?.accountLedgerId);
  }
  //#endregion

  //#region Credit/Debit Note
  getAgainstData() {
    if (this.formModel?.invoiceModel?.accountLedgerId && this.formModel?.invoiceModel?.againstVoucherTypeId) {
      const requestData = { accountLedgerId: this.formModel?.invoiceModel?.accountLedgerId, voucherTypeId: this.formModel?.invoiceModel?.againstVoucherTypeId,fromSettings:false};
      this.transactionService.getagainstdropdownbyaccountledgerandvouchertypeid(requestData).subscribe({
        next: (res) => {
          this.copiedAgainstDropdown = res?.response;
          this.againstInvoiceDropdown?.setDataSource(this.copiedAgainstDropdown);
        },
      })
    }
  }
  //#endregion

  //#region Of Get Data For Other Invoice By There VoucherTypeId
  fillDataForOtherInvoices(invoiceId, voucherTypeId) {
    this.transactionService.getInvoiceById(voucherTypeId, invoiceId).subscribe(res => {
      this.formModel = res?.response;
      this.formModel.itemList.forEach(element => {
        element.againstVoucherTypeId = voucherTypeId;
        element.jobworkOrderItemId = voucherTypeId == VoucherType.JobworkOrder ? element?.id : null;
        element.againstVoucherNo = element?.id;
        element.jobworkOrderVoucherTypeId = voucherTypeId == VoucherType.JobworkOrder ? voucherTypeId : null;
        element.id = 0;
      });
      this.formModel.paymentList = [];
      this.formModel.voucherType = this.commonVoucherModel?.voucherType;
      this.formModel.invoiceModel.voucherTypeId = this.commonVoucherModel?.voucherTypeId;
      this.formModel.invoiceModel.againstVoucherTypeId = voucherTypeId;
      this.formModel.invoiceModel.againstVoucherNo = this.formModel?.invoiceModel?.id;
      this.formModel.invoiceModel.accountLedgerId = this.formModel?.invoiceModel?.accountLedgerId;
      this.formModel.invoiceModel.againstInvoiceNo = this.formModel?.invoiceModel?.invoiceNo;
      if(this.commonVoucherModel?.voucherTypeId == VoucherType.JobworkInvoice)
      this.formModel.invoiceModel.saleOrderAccountLedgerId = this.storageService.retrieve(StorageName.STORED_SALE_ORDER_ACCOUNTLEDGERID);
      this.formModel.invoiceModel.id = 0;
      this.updateAccountLedgerDropdownSource(this.formModel?.invoiceModel?.departmentId);
      this.assignAccountLedgerId(this.formModel?.invoiceModel?.accountLedgerId);
      this.onItemListChange(this.formModel);
    });
  }
  //#endregion

  processDataForJobworkInvoice(data) {
    this.transactionService.processDataForJobworkInvoice(data).subscribe(res => {
      this.formModel.itemList = res?.response;
      this.formModel.invoiceModel.departmentId = data[0]?.departmentId;
      this.formModel.invoiceModel.accountLedgerId = data[0]?.departmentUserId;
      this.formModel.invoiceModel.againstInvoiceNo = data[0]?.jobworkOrderInvoiceNo;
      this.formModel.invoiceModel.againstVoucherTypeId = data[0]?.jobworkOrderVoucherTypeId;
      this.formModel.invoiceModel.againstVoucherNo = data[0]?.jobworkOrderVoucherNo;
      setTimeout(() => {
        this.storageService.getInvoice.next({ response: this.formModel });
        this.onItemListChange(this.formModel);
        this.updateAccountLedgerDropdownSource(this.formModel?.invoiceModel?.departmentId)
      }, 1000);
    });
  }
  //#endregion

  //#region  JobworkOrder
  fillFromSaleOrder(data) {
    if (!(data?.length > 0))
      data = [data]
    var voucherTypeId = data[0]?.againstVoucherTypeId;
    switch (voucherTypeId) {
      case VoucherType.SalesOrder:
      case VoucherType.RepairOrder:
        // this.formModel.invoiceModel.fromScrapInvoiceItem = false;
        // this.formModel.itemList = data;
        const formModel:any = {};
        formModel.itemList = data;
        const invoiceDataModel = data[0];
        formModel.invoiceModel = {...invoiceDataModel ,...this.formModel.invoiceModel }
        formModel.invoiceModel.fromScrapInvoiceItem = false;
        formModel.invoiceModel.comment = formModel?.invoiceModel?.invoiceComment;
        if(formModel.invoiceModel?.againstVoucherTypeId == VoucherType.SalesOrder)
        formModel.invoiceModel.saleOrderAccountLedgerId = invoiceDataModel?.accountLedgerId; 
        this.formModel = formModel;
        setTimeout(() => {
          this.storageService.getInvoice.next({ response: { itemList: this.formModel.itemList } });
        }, 100);
        break;
        // case VoucherType.RepairOrder:
        //   this.formModel.invoiceModel.fromScrapInvoiceItem = false;
        //   this.formModel.itemList = data;
        //   setTimeout(() => {
        //     this.storageService.getInvoice.next({ response: { itemList: this.formModel.itemList } });
        //   }, 100);
        //   break;
      case VoucherType.OldJewelryScrapInvoice:
        this.formModel.invoiceModel.fromScrapInvoiceItem = true;
        setTimeout(() => {
          data.forEach(element => {
            this.storageService.onAddProductsInPaymentList.next({ response: element, voucherTypeId: VoucherType.OldJewelryScrapInvoice, addNewRow: true, rowIndex: undefined });
          });
        }, 100);
        break;
    }

    const uniqueInvoiceNumbers = [...new Set(data.map(a => a?.invoiceNo))];
    const invoiceNo = uniqueInvoiceNumbers.join(', ');
    this.formModel.invoiceModel.againstRefNo = invoiceNo;
    this.formModel.invoiceModel.customerId = data[0]?.customerId;
    this.invoiceDate = data[0]?.invoiceDate;
    !this.invoiceDate ? this.invoiceDateComponent?.getupdateCurrentDate() : ''
    this.dueDate = data[0]?.dueDate;
    !this.dueDate ? this.dueDateComponent.getupdateCurrentDate() : ''
    this.customSelect2Component?.setDropdownText(String(this.formModel?.invoiceModel?.accountLedgerId));
  }

  updateJobworkOrderStatus(id) {
    this.formModel.invoiceModel.statusId = id;
    if (this.formModel.invoiceModel.id != 0 && this.formModel.invoiceModel.id != undefined)
      this.transactionService.updateJobworkOrderStatus(this.formModel).pipe(catchError((err) => this.handleError(err))).subscribe((res: ResponseModel) => {
        if (res?.isSuccess) {
          this.toaster.success(res?.message);
          if (this.formModel?.invoiceModel?.statusId === JobWorkStatus.Completed.toString()) {
            this.formModel.invoiceModel.notificationTemplateName = 'SaleOrderCompletedTemplate';
            this.reportService.processResponse(res, this.formModel?.invoiceModel, this.notificationConfigurationModel, false)
          }
        }
      });
  }

  updateJobworkOrderPriority(id) {
    if (id === '0')
      this.toaster.error('Please Select Priority');
    else {
      this.formModel.invoiceModel.priorityId = id;
      if (this.formModel?.invoiceModel?.id != 0 && this.formModel?.invoiceModel?.id != undefined)
        this.transactionService.updateJobworkOrderPriority(this.formModel).pipe(catchError((err) => this.handleError(err))).subscribe((res: ResponseModel) => {
          if (res?.isSuccess)
            this.toaster.success(res?.message);
        });
    }
  }
  //#endregion
  //#region Expenses

  onGridReady(event ,ID) {
    switch (ID) {
      case 1:
        this.gridApiExpenses = event;
        const getcolumns = this.gridApiExpenses?.columnApi.getAllColumns();
        this.allColumns = getcolumns?.map(column => column?.getColDef());
        break;
    
      case 2:
        this.gridApiFixingDirect = event;
        break;
    }
   
  }
  onChangeSwitch(event: any) {
    this.formModel.invoiceModel.expensesWithTax = event; // Update the expensesWithTax variable
    this.visibleTaxColumn(); // Call the method to show/hide columns
  }
  onCellValueChangedDetect(params) {
    this.calculatetaxwithamount(params);
    this.updateFooterRow();
  }

  calculatetaxwithamount(params: any): void {
    const amount = params?.data?.amount || null;
    
    const taxdropdown = this.getAllDropdownModel?.taxDropdown?.find(a => a.id == params?.data?.taxId?.toString());
    if (taxdropdown) {
      const taxRate = taxdropdown?.extra3 ? parseFloat(taxdropdown?.extra3) : 0;
      const taxAmount = (Number(amount) * taxRate) / 100;
      const taxWithAmount = Number(amount) + taxAmount;
      params.data.taxAmount =  this.textProcessingService.fixAmountDecimal(taxAmount);
      params.data.netAmountWithTax =  this.textProcessingService.fixAmountDecimal(taxWithAmount);
      this.gridApiExpenses?.api?.refreshCells();
    }
    else
    {
      params.data.taxAmount = 0;
      params.data.netAmountWithTax =  Number(this.textProcessingService.fixAmountDecimal(amount));
    }
    
    this.formModel.itemList = this.gridApiExpenses?.api?.getModel()?.rowsToDisplay?.map(a => a?.data);
    this.totalSectionComponent.getCalculatedInvoiceDetails(this.formModel);
  }


  updateFooterRow(): void {
    if (this.gridApiExpenses) {
      const rowsdata = this.gridApiExpenses?.api?.getModel()?.rowsToDisplay?.map(a => a?.data);
      const sumOfNetAmountWithTax = (rowsdata?.map(a => Number(a?.netAmountWithTax))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0);
      const sumOfNetAmount = (rowsdata?.map(a => Number(a?.amount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0);
      const amount = sumOfNetAmount;
      const totalsObject = {
        netAmountWithTax: this.textProcessingService.fixAmountDecimal(sumOfNetAmountWithTax),
        amount: sumOfNetAmount,
        isFooterRow: true
      };
      this.gridApiExpenses.api.setPinnedBottomRowData([totalsObject]);
      this.gridApiExpenses.api.refreshCells();
    }
  }
  visibleTaxColumn() {
    var columnnames = ["taxId", "netAmountWithTax"]
    columnnames.forEach(element => { this.gridApiExpenses?.columnApi?.setColumnVisible(element, this.formModel?.invoiceModel?.expensesWithTax); });
    const columnState = this.gridApiExpenses?.columnApi?.getColumnState();
    const hiddenColumnsDetails = columnState.filter(col => columnnames?.includes(col?.colId) && col?.hide)?.map(col => ({ colId: col?.colId, headerName: col?.headerName }));
    // Emit hidden columns with details via BehaviorSubject
    this.agGridService?.hiddenColumnsdisableSubject.next(hiddenColumnsDetails);
    this.onDeleteExpense();
  }
  //#endregion

  //#region  stockJournal option 2

  onPrintBarcodeClick(){
    var data =  this.itemListSectionComponent?.gridApi?.api?.getSelectedRows();
    this.formModel.itemList  =  data
    this.stockJournalService.print(this.formModel).subscribe({
      next:(res)=>{
        if(res?.isSuccess){
          this.toaster.success(res?.message);
        }
      },error:(err)=>{
      }
    })
  }

  removeItemFromItemListByBarcodeNo(result)
  {
    this.formModel.itemList =  this.formModel.itemList.filter(a=>a?.barcodeNo != result)
    this.itemListSectionComponent.getInvoiceResponse(this.formModel);
    this.onItemListChangeResponse.emit(this.formModel);
  }


  fillFromStockJournalOption2StoredData(data) {
    if(this.isBlankUndefinedOrNull(data.voucherNo) || data.voucherNo == 0)
    {
      this.formModel.invoiceModel.againstVoucherTypeId = data?.againstVoucherTypeId;
      this.formModel.invoiceModel.againstVoucherNo = data?.againstVoucherNo;
      this.formModel.invoiceModel.againstInvoiceNo = data?.againstInvoiceNo;
      this.formModel.invoiceModel.id = data?.id;

      this.formModel.diamondRate = data?.diamondRate;
      this.formModel.diamondGoldRate = data?.diamondGoldRate;
      this.formModel.diamondMakingRate = data?.diamondMakingRate;
      this.formModel.diamondMakingTypeId= data?.diamondMakingTypeId;
      this.formModel.goldRate = data?.goldRate;
      this.formModel.goldMakingRate = data?.goldMakingRate;
      this.formModel.goldMakingTypeId = data?.goldMakingTypeId;
    }
    else this.getStockJournalMovementById(data?.voucherNo);
  }
  getStockJournalMovementById(id) {
    this.transactionService.getStockJournalMovementById(this.commonVoucherModel?.voucherTypeId,id).subscribe(res => {
      if (res.isSuccess) {
        this.voucherTypeName = this.reportService.getVoucherTypeText(this.commonVoucherModel?.voucherTypeId.toString());
        this.onGetByIdResponse.emit(res?.response);
        this.formModel = res?.response;
        this.formModel.isInReference = true;
        this.formModel.voucherType = this.commonVoucherModel?.voucherType;
        this.formModel.invoiceModel.voucherTypeId = this.commonVoucherModel?.voucherTypeId;
        this.invoiceDate = this.formModel?.invoiceModel?.date;
      }
    });
  }
  //#endregion stockJournal option 2
  onPaymentListChanged(params) {
    this.totalSectionComponent?.getCalculatedInvoiceDetails(this.formModel);
  }
  
  //#region Exchange Rate
  AddUpdateExchangeRate(){
    if(this.formModel?.invoiceModel?.exchangeRateId){
      this.invoiceService.getcurrencyexchangeratebyid(this.formModel?.invoiceModel?.exchangeRateId).subscribe({
        next: (res) => {
          if (res?.isSuccess) 
            var data = { getAllDropdownModel: this.getAllDropdownModel ,insertUpdateCurrencyExchangeRate: res?.response}
          else
          {
            res.response = {};
            res.response.currencyId = this.formModel?.invoiceModel?.exchangeRateId;
            var data = { getAllDropdownModel: this.getAllDropdownModel ,insertUpdateCurrencyExchangeRate: res?.response}
          }
            // res.response = {}
            // var data = { getAllDropdownModel: this.getAllDropdownModel ,insertUpdateCurrencyExchangeRate: res?.response}
            this.notificationService.openModalPopup(ExchangeRatesComponent, data,'').then(
              (resultData) => {
                if (resultData) {
                }
              }
            );
        
        }, error: (err) => {
          
        }
      });
    }
  }

  onFileSelected(event: any) {
    const file = event?.target?.files?.[0];
     if (file) {
     event.target.value = ""; 
     this.selectedFile = file;
     this.fileName = file?.name;
   }
  }

  uploadFile() {
    if (this.selectedFile) {
      this.transactionService.uploadedFile(this.selectedFile).subscribe({
        next:(res)=>{
          if(res?.isSuccess){
            this.loadDropdownDataComponent?.getInvoiceNo();
            this.paymentListComponent?.getAllVoucherData();
            this.toaster.success(res?.message);
            this.selectedFile = null;
            this.fileName =null;
          } else this.toaster.error(res?.errors[0]);
        },error:(err)=>{ this.toaster.error(err?.errors[0]); }
      })
    }
  }

  getsamplefilebypagename(){
    const requestData = {pageName:this.commonVoucherModel?.formName}
     this.mastersService.getsamplefilebypagename(requestData).subscribe({
       next:(res)=>{
         if(res?.isSuccess){
             this.FilePath = res?.response;
         }
       },error:(err)=>{
       }
     })
  }

  downloadSampleFile() {
    this.excelConverterServiceService.downloadXlsx(this.FilePath);
  }

  convertImageToBase64(imagePath: string): Promise<string> {
    return this.http
      .get(imagePath, { responseType: 'blob' })
      .toPromise()
      .then(blob => {
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
  }
  

  //region Fixing
  onCellValueFixingDirectChangedDetect(params) {
    this.addFooterAndCalculationForFixing(params);
  }
  onDeleteFixingDirect(params){
  this.gridApiFixingDirect?.api?.applyTransaction({remove : [params?.detail?.data?.data]});
  this.addFooterAndCalculationForFixing(params?.detail?.data);
  }

  addFooterAndCalculationForFixing(params?) {
    params.data = this.metalSectionService.calculateRate(params?.data,this.formModel?.invoiceModel?.ounceRate,MetalType.Gold);
    params.data.rate =  this.textProcessingService.fixWeightDecimal(params?.data?.rate);
    if(params){
      params.data.purityWt = this.textProcessingService.fixWeightDecimal(Number(params?.data?.grossWt ?? 0) * Number(params?.data?.purityPer));
      params.data.amount = this.textProcessingService.fixAmountDecimal(Number(params?.data?.purityWt ?? 0) * Number(params?.data?.rate ?? 0));
    }
    const rowsData = this.gridApiFixingDirect?.api?.getModel()?.rowsToDisplay?.map(a => a?.data);
    const sumOfAmount = rowsData?.map(a => Number(a?.amount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0;
    const sumOfPurityWt = rowsData?.map(a => Number(a?.purityWt))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0;
    const sumOfGrossWt = rowsData?.map(a => Number(a?.grossWt))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0;
    this.formModel.invoiceModel.totalamount = Number(sumOfAmount); 
    this.formModel.invoiceModel.totalPurityWt = Number(sumOfPurityWt); 
    this.formModel.invoiceModel.totalGrossWt = Number(sumOfGrossWt); 
    this.formModel.itemList = rowsData;
    this.gridApiFixingDirect?.api?.refreshCells();
  }
  
  openJournalVouchersPopup() {
    let data = { formModel: this.formModel }
    this.notificationService.openModalPopup(JournalVouchersPopupComponent, data, '', ModalPopupSize.XL, '', false, true).then((result) => {
      if (result) {

      }
    })
  }

  selectHedging(fixingTypeId){
    this.formModel.invoiceModel.fixingTypeId = fixingTypeId;
    this.formModel.invoiceModel.internalFix = (fixingTypeId == FixingType.Hedging) ? true : false;
    this.formModel.invoiceModel.metalFix = fixingTypeId === FixingType.Hedging && false;
  }

//#region  Opening AgGrid Cell Search Dropdown
  isPopupOpen = false;
  gridOptions = {
    context: { componentParent: this },
    onCellKeyDown: this.handleCellEvent.bind(this),
    onCellClicked: this.handleCellEvent.bind(this)
  };

  handleCellEvent(event): void {
    event?.event?.stopPropagation();
    if ('ArrowDown' === event?.event?.key || event?.type === 'cellClicked') {
      setTimeout(() => {
        const focusedCell = event?.api?.getFocusedCell();
        const colId = focusedCell?.column?.getColId();
        if (!this.commonAgGridDropdownService.isPopupOpen && ['expensesCategoryId'].includes(colId) && event?.rowIndex != null) {
          const rowNode = event?.api?.getDisplayedRowAtIndex(event?.rowIndex);
          const currentselectedId = String(rowNode?.data?.[colId]);
          this.commonAgGridDropdownService.openDropdownPopup({rowNode,colId,currentselectedId,tabId: 0,gridApi : event?.api});
        }
      }, 0);
    }
  }
//#region  Opening AgGrid Cell Search Dropdown end
barcodeDisabled(): boolean {
  const selectedRows = this.itemListSectionComponent?.gridApi?.api?.getSelectedRows();
  return !selectedRows || selectedRows.length === 0;
}

checkIfRowSelected(): boolean {
  return (this.itemListSectionComponent?.gridApi?.api?.getModel()?.rowsToDisplay.map((a) => a.data).some((x) => x?.active === true && !x?.isReceived) || false);
}

  updateStockTransferReceivedStatus() {
    const data = (this.itemListSectionComponent?.gridApi?.api?.getSelectedRows() || []).filter(x => !x?.isReceived);
    const selectedInvoiceIds = data?.map(row => row?.id);
    const requestData = {
      ids: selectedInvoiceIds,
      isInvoice: false
    };
    this.transactionService.updatestocktransferreceivedstatus(requestData).subscribe({
      next: (res) => {
        this.toaster.success(res?.message);
        this.getById();
      },
      error: (err) => {
      },
    });
  }
}